import { FetchAPI, ParamsSerializer } from './auth-service';

const fields = [
    {
        variable: 'name',
        hidden: false,
        hiddenByColumnsButton: true,
        title: 'Name',
        field: 'data.name',
        defaultSort: 'desc',
        type: 'str',
    },
    {
        variable: 'ip',
        hidden: false,
        hiddenByColumnsButton: true,
        title: 'IP',
        field: 'data.ip',
        type: 'str',
    },
    {
        variable: 'created',
        hidden: false,
        hiddenByColumnsButton: true,
        title: 'Created',
        field: 'data.created',
        type: 'str',
    },
];

const MC2CHECK = process.env.BRICATA_APPLIANCE_TYPE === 'mc2';

class AssetsDataService {
    constructor () {
        if (!AssetsDataService.instance) {
            AssetsDataService.instance = this;
        }
        this.searchPlaceholder = 'Search assets';
        this.fields = fields;

        this.getAssets = (search, cmc) => {
            if (MC2CHECK && !cmc) return Promise.resolve('no cmc');
            const prefix = MC2CHECK && cmc ? `mc2/cmcapi/${cmc}/` : '';

            const params = {
                q: search || '',
            };

            return FetchAPI({ method: 'GET', url: `${prefix}system/assets?${ParamsSerializer(params)}` })
                .then(res => {
                    if (!res) res = { objects: [] };
                    self.asof = res.timestamp;
                    this.data = res.objects || [];

                    return {
                        data: this.data,
                        page: 1,
                        totalCount: this.total || (res.objects || []).length,
                    };
                });
        };

        this.getAssetsMap = (search, cmc) => {
            if (MC2CHECK && !cmc) return Promise.resolve('no cmc');
            const prefix = MC2CHECK && cmc ? `mc2/cmcapi/${cmc}/` : '';

            const params = {
                q: search || '',
            };

            return FetchAPI({ method: 'GET', url: `${prefix}system/assetsmap?${ParamsSerializer(params)}` })
                .then(res => {
                    if (!res) res = { objects: [] };
                    self.asof = res.timestamp;
                    this.data = res.objects || [];

                    return {
                        data: this.data
                    };
                }, err => {
                    return err;
                });
        };

        this.getSavedSearches = () => {
            try {
                let searches = localStorage.getItem('savedSearches_assets') || '[]';
                if (searches.length < 1) searches = '[]';
                return JSON.parse(searches);
            } catch (err) {
                console.log('getSavedSearches error', err);
                return [];
            }
        };

        this.saveSearch = (str) => {
            if (!str || !str.length) return;
            const searches = this.getSavedSearches();
            const i = searches.findIndex(s => s === str);
            if (i >= 0) searches.splice(i, 1);
            searches.unshift(str);
            searches.splice(5);
            localStorage.setItem('savedSearches_assets', JSON.stringify(searches));
        };

        this.createAsset = (data, cmc) => {
            if (MC2CHECK && !cmc) return Promise.resolve('no cmc');
            const prefix = MC2CHECK && cmc ? `mc2/cmcapi/${cmc}/` : '';

            return FetchAPI({
                method: 'POST',
                url: `${prefix}system/assets`,
                body: data,
            });
        };

        this.getAsset = (ip, cmc) => {
            if (MC2CHECK && !cmc) return Promise.resolve('no cmc');
            const prefix = MC2CHECK && cmc ? `mc2/cmcapi/${cmc}/` : '';

            return FetchAPI({
                method: 'GET',
                url: `${prefix}system/assets/${encodeURIComponent(ip)}`,
            });
        };

        this.updateAsset = (ip, data, cmc) => {
            if (MC2CHECK && !cmc) return Promise.resolve('no cmc');
            const prefix = MC2CHECK && cmc ? `mc2/cmcapi/${cmc}/` : '';

            return FetchAPI({
                method: 'PUT',
                url: `${prefix}system/assets/${encodeURIComponent(ip)}`,
                body: data,
            });
        };

        this.import = ({ data, overwrite }, cmc) => {
            return FetchAPI({
                method: 'PUT',
                url: 'system/assets/-import',
                body: data,
            });
        };

        this.deleteAsset = (ip, cmc) => {
            if (MC2CHECK && !cmc) return Promise.resolve('no cmc');
            const prefix = MC2CHECK && cmc ? `mc2/cmcapi/${cmc}/` : '';

            return FetchAPI({
                method: 'DELETE',
                url: `${prefix}system/assets/${encodeURIComponent(ip)}`,
            });
        };

        this.getLookup = (ip, cmc) => {
            if (MC2CHECK && !cmc) return Promise.resolve('no cmc');
            const prefix = MC2CHECK && cmc ? `mc2/cmcapi/${cmc}/` : '';

            return FetchAPI({
                method: 'GET',
                url: `${prefix}system/dns/${encodeURIComponent(ip)}/_lookup_addr`,
            });
        };

        this.getLookupFromSensor = (uuid, ip, cmc) => {
            if (MC2CHECK && !cmc) return Promise.resolve('no cmc');
            const prefix = MC2CHECK && cmc ? `mc2/cmcapi/${cmc}/` : '';

            return FetchAPI({
                method: 'GET',
                url: `${prefix}system/dns/${uuid}/${encodeURIComponent(ip)}/_lookup_addr`,
            });
        };

        this.passiveLookup = (ip, cmc) => {
            if (MC2CHECK && !cmc) return Promise.resolve('no cmc');
            const prefix = MC2CHECK && cmc ? `mc2/cmcapi/${cmc}/` : '';

            return FetchAPI({
                method: 'GET',
                url: `${prefix}system/passive_dns/${encodeURIComponent(ip)}/_lookup_addr`,
            });
        };

        return AssetsDataService.instance;
    }
}
const AssetsService = new AssetsDataService();

export {
    AssetsService as default,
    fields
};
